import { render, staticRenderFns } from "./BaseLoader.vue?vue&type=template&id=49d66882&scoped=true&"
import script from "./BaseLoader.vue?vue&type=script&lang=ts&"
export * from "./BaseLoader.vue?vue&type=script&lang=ts&"
import style0 from "./BaseLoader.vue?vue&type=style&index=0&id=49d66882&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d66882",
  null
  
)

export default component.exports